import { useState } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Wallet, Users, Star, FileText, HelpCircle, Ticket, Mail, Settings, ScrollText, LogOut, Menu, X, Home } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/services", icon: Package, label: "Services" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Orders" },
  { to: "/admin/payments", icon: Wallet, label: "Payments & Wallets" },
  { to: "/admin/customers", icon: Users, label: "Customers" },
  { to: "/admin/testimonials", icon: Star, label: "Testimonials" },
  { to: "/admin/blog", icon: FileText, label: "Blog" },
  { to: "/admin/faq", icon: HelpCircle, label: "FAQ" },
  { to: "/admin/coupons", icon: Ticket, label: "Coupons" },
  { to: "/admin/contact", icon: Mail, label: "Messages" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
  { to: "/admin/audit", icon: ScrollText, label: "Audit Log" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navg = useNavigate();
  const [open, setOpen] = useState(false);

  const Inner = () => (
    <>
      <div className="p-5 border-b border-white/5"><Logo size="sm" to="/admin" /></div>
      <nav className="flex-1 px-3 py-3 space-y-0.5 overflow-y-auto">
        {nav.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`admin-nav-${n.to.split("/").pop() || "dashboard"}`}
            className={({ isActive }) => `flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium transition-all ${isActive ? "bg-gradient-to-r from-amber-400/20 to-amber-600/5 text-amber-400 border border-amber-500/30" : "text-slate-400 hover:text-white hover:bg-white/5"}`}>
            <n.icon size={17} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/5 space-y-1">
        <Link to="/" className="flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm text-slate-400 hover:text-white hover:bg-white/5"><Home size={17} /> View Site</Link>
        <button onClick={() => { logout(); navg("/admin/login"); }} className="w-full flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm text-slate-400 hover:text-red-400 hover:bg-white/5" data-testid="admin-logout"><LogOut size={17} /> Logout</button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-[#0B0C0E] flex">
      <aside className="hidden lg:flex flex-col w-64 border-r border-amber-500/15 bg-[#0e1013] fixed inset-y-0">{Inner()}</aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-[#0e1013] border-r border-amber-500/15 flex flex-col">{Inner()}</div>
          <div className="flex-1 bg-black/60" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="glass border-b border-amber-500/15 sticky top-0 z-30 flex items-center justify-between px-4 sm:px-6 h-16">
          <button className="lg:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="admin-mobile-toggle">{open ? <X size={22} /> : <Menu size={22} />}</button>
          <div className="ml-auto text-sm text-slate-400">Signed in as <span className="text-amber-400 font-semibold">{user?.email}</span></div>
        </header>
        <main className="p-4 sm:p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
